const sortOptions = [
  { label: "综合排序", value: "comprehensive" },
  { label: "价格低→高", value: "price_asc" },
  { label: "评分优先", value: "rating" },
  { label: "好评优先", value: "reviews" },
];

interface SortBarProps {
  activeSort: number;
  onSortChange: (index: number) => void;
}

export default function SortBar({ activeSort, onSortChange }: SortBarProps) {
  return (
    <div className="flex border-t border-gray-100">
      {sortOptions.map((s, i) => (
        <button
          key={s.label}
          onClick={() => onSortChange(i)}
          className="flex-1 py-2 text-xs font-medium cursor-pointer whitespace-nowrap transition-colors"
          style={{
            color: activeSort === i ? "#1E3A8A" : "#9CA3AF",
            borderBottom: activeSort === i ? "2px solid #1E3A8A" : "2px solid transparent",
          }}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}

// 导出排序值映射供外部使用
export const SORT_VALUE_MAP: Record<number, string> = {
  0: "comprehensive",
  1: "price_asc",
  2: "rating",
  3: "reviews",
};
